import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import ActiveEmc from "../../../Assets/AppComponent/Group 309.svg";
import InActiveEmc from "../../../Assets/AppComponent/Group 309 (1).svg";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import {
  getCasualApproveRequestActionListed,
  SetCasualActiveTabs,
  SetCasualAddressId,
  setCasualBankDetailsId,
  SetCasualBasiformsID,
  SetCasualFamilyDetailsId,
  SetCasualJobOfferID,
  SetCasualReferncesId,
} from "../../../Redux/Slice";
import CasualBasicInfoTab from "./CasualBasicInfoTab";
import CasualAddresDetails from "./CasualAddresDetails";
import CasualJobInfo from "./CasualJobInfo";
import CasualBankDetails from "./CasualBankDetails";
import CasualFamilyDetails from "./CasualFamilyDetails";
import CasualRefernceDetails from "./CasualRefernceDetails";

const CasualFormTab = () => {
  const { id } = useParams();
  const state = useSelector((state) => state);
  const [UserName, setUserName] = useState("");

  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  useEffect(() => {
    const payloads = {
      casual_labour_id: id,
    };
    dispatch(getCasualApproveRequestActionListed(payloads));
  }, [id]);

  useEffect(() => {
    console.log(state.CasualApproveRequestDatas.Inquriy, "djkasdjhasjdjasjkda");
    const responseData = state.CasualApproveRequestDatas.Inquriy;
    setUserName(responseData.first_name);
  }, [state.CasualApproveRequestDatas.Inquriy]);
  const navigate = useNavigate();
  const [counts, setCounts] = useState(1);

  const [RoleName, setRoleNames] = useState("");
  const [EmpActive, setEmpActive] = useState();
  const CountingFunctions = (countNumber) => {
    setCounts(countNumber);
  };
  const dispatch = useDispatch();
  return (
    <div className="FormTab">
      <div className={stateDisplay ? "POPUP" : "outerPOPUP"}>
        {" "}
        <div className="Header-Details ClientBranch row">
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              paddingLeft: "0px",
            }}
          >
            <h3>Employee Form Details </h3>
          </div>
        </div>
        <div
          className="row Filters ButtonPrevious"
          style={{ padding: "12px 0px" }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                // navigate("/employeeVerifylist");

                navigate(
                  `/casualemployeeprofile/${id}`,
                  // fieldagent"
                );
              }}
            >
              <img className="PreviousPages" src={BackImage} />
              <span></span>
            </button>
          </div>
        </div>
        <div className="Header-Details" style={{ marginTop: "20px" }}>
          <div className="InnerDetails">
            <div className="InnerDetailPart">
              <div className="LOGO">
                <img src={profile2} />
              </div>

              <p className="EMpCODER">
                <span style={{ textTransform: "captilize" }}>{UserName}</span>
              </p>
            </div>
            <div className="ROLE">
              <div className="LOGO EMCANDACTIVE">
                {EmpActive == true && RoleName != "" ? (
                  <>
                    <span>Active</span>
                    <span className="ActiveImage">
                      <img src={ActiveEmc} />
                    </span>
                  </>
                ) : EmpActive == false && RoleName != "" ? (
                  <>
                    <span>Inactive</span>
                    <span className="ActiveImage">
                      <img src={InActiveEmc} />
                    </span>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        {console.log(state?.CasualFormsIDList, "CasualFormsIDList")}
        <div className="row">
          <div className="col-md-12">
            <div className="row"></div>
            <div class="profile-header">
              <div class="row" style={{ padding: "15px" }}>
                <div className="col-md-12 profile-menu TabsStartHead">
                  <div className="innerTabs">
                    <ul class="nav nav-tabs" id="ex1" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          // class="nav-link active"
                          className={` ButtonCSS nav-link  ${state.CasualFormsIDList.CasualActiveTabs == 1
                              ? "active"
                              : ""
                            }`}
                          id="ex3-tab-1"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-1"
                          role="tab"
                          aria-controls="ex3-tabs-1"
                          aria-selected="true"
                          onClick={(e) => {
                            CountingFunctions(1);

                            dispatch(SetCasualActiveTabs(1));
                          }}
                        >
                          Basic Information
                        </button>
                      </li>
                      <li class="nav-item " role="presentation">
                        <button
                          //class="nav-link "
                          className={` ButtonCSS  nav-link  ${state.CasualFormsIDList.CasualActiveTabs == 2
                              ? "active"
                              : ""
                            }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-2"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          // onClick={(e) => {
                          //   Counting(2);
                          // }}

                          //  disabled={
                          //   state.EmployeeProfile.EmployeeProfileList
                          //     .address_details  == null ||
                          //   state.FormsIDList.AddressId == "" ? true : false
                          //  }
                          onClick={(e) => {
                            CountingFunctions(2);

                            dispatch(SetCasualActiveTabs(2));
                          }}
                        >
                          Address Details
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //class="nav-link"
                          className={` ButtonCSS nav-link  ${state.CasualFormsIDList.CasualActiveTabs == 3
                              ? "active"
                              : ""
                            }`}
                          id="tab10"
                          data-bs-toggle="tab"
                          href="#tabs10"
                          role="tab"
                          aria-controls="tab10"
                          aria-selected="false"
                          onClick={(e) => {
                            CountingFunctions(3);

                            dispatch(SetCasualActiveTabs(3));
                          }}
                        >
                          Job Information
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //  class="nav-link"
                          className={`  ButtonCSS nav-link  ${state.CasualFormsIDList.CasualActiveTabs == 4
                              ? "active"
                              : ""
                            }`}
                          id="tab4"
                          data-bs-toggle="tab"
                          href="#tabs4"
                          role="tab"
                          aria-controls="tab4"
                          aria-selected="false"
                          onClick={(e) => {
                            CountingFunctions(4);

                            dispatch(SetCasualActiveTabs(4));
                          }}
                        >
                          Bank Details
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //class="nav-link"
                          className={`  nav-link  ${state.CasualFormsIDList.CasualActiveTabs == 5
                              ? "active"
                              : ""
                            }`}
                          id="tab7"
                          data-bs-toggle="tab"
                          href="#tabs7"
                          role="tab"
                          aria-controls="tab7"
                          aria-selected="false"
                          onClick={(e) => {
                            CountingFunctions(5);

                            dispatch(SetCasualActiveTabs(5));
                          }}
                        >
                          Family Details
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          // class="nav-link"
                          className={` ButtonCSS   nav-link  ${state.CasualFormsIDList.CasualActiveTabs == 6
                              ? "active"
                              : ""
                            }`}
                          id="tab8"
                          data-bs-toggle="tab"
                          href="#tabs8"
                          role="tab"
                          aria-controls="tab8"
                          aria-selected="false"
                          onClick={(e) => {
                            CountingFunctions(6);

                            dispatch(SetCasualActiveTabs(6));
                          }}
                        >
                          References
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div>
                    {state.CasualFormsIDList.CasualActiveTabs == 1 ? (
                      <CasualBasicInfoTab
                        propsID={id} />
                    ) : state.CasualFormsIDList.CasualActiveTabs == 2 ? (
                      <CasualAddresDetails
                        propsID={id} />
                    ) : state.CasualFormsIDList.CasualActiveTabs == 3 ? (
                      <CasualJobInfo
                        propsID={id} />
                    ) : state.CasualFormsIDList.CasualActiveTabs == 4 ? (
                      <CasualBankDetails
                        propsID={id} />
                    ) : state.CasualFormsIDList.CasualActiveTabs == 5 ? (
                      <CasualFamilyDetails
                        propsID={id} />
                    ) : state.CasualFormsIDList.CasualActiveTabs == 6 ? (
                      <CasualRefernceDetails
                        propsID={id} />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CasualFormTab;
